export const SPORTSNEW_MODES = ['prematch', 'live', 'all'];
export const SPORTSNEW_SPORTS = ['soccer', 'baseball', 'basketball', 'volleyball', 'ice-hockey', 'esports'];
export const SPORTSNEW_DISPLAY_SCOPES = ['overseas', 'domestic', 'live', 'esports'];

export const SPORTSNEW_WS_DEBUG = ['1', 'true'].includes(
  String(process.env.REACT_APP_SPORTSNEW_WS_DEBUG || '').toLowerCase(),
);

export const normalizeSportsnewComboBonus = value => {
  const data = value?.data ?? value;
  const tiers = Array.isArray(data)
    ? data
    : data?.tiers || data?.comboBonusTiers || data?.combo_bonus_tiers || data?.comboBonus?.tiers || [];
  if (!Array.isArray(tiers)) return [];
  return tiers
    .map(tier => {
      const fold = Number(tier.fold ?? tier.min_legs ?? tier.minLegs);
      const multiplier = Number(tier.value ?? tier.multiplier);
      const rate = Number(tier.ratePercent ?? tier.rate_percent);
      const resolvedValue = Number.isFinite(multiplier) && multiplier >= 1
        ? multiplier
        : Number((1 + (Number.isFinite(rate) ? rate : 0) / 100).toFixed(4));
      if (!Number.isFinite(fold) || fold < 2 || !Number.isFinite(resolvedValue) || resolvedValue <= 1) {
        return null;
      }
      return { ...tier, fold, value: resolvedValue };
    })
    .filter(Boolean)
    .sort((a, b) => a.fold - b.fold);
};

const sportFallbackOrder = (slug) => {
  const index = SPORTSNEW_SPORTS.indexOf(slug);
  return index >= 0 ? index + 1 : SPORTSNEW_SPORTS.length + 1;
};

const categorySortOrder = (category) => {
  const value = Number(category?.sortOrder ?? category?.sort_order);
  return Number.isFinite(value) && value > 0 ? value : sportFallbackOrder(category?.slug);
};

export const normalizeFixtureRoomPatch = (patch = {}) => {
  if (!Array.isArray(patch?.marketSnapshot)) return patch;
  return {
    ...patch,
    markets: patch.marketSnapshot,
    projectionScope: patch.projectionScope ?? patch.projection_scope ?? 'full',
    isFullFixtureProjection: true,
  };
};

export const recoverFixtureSnapshotPayload = (payload) => {
  const snapshot = payload?.snapshot && typeof payload.snapshot === 'object'
    ? payload.snapshot
    : null;
  const isRecoveryEnvelope = payload && (
    Object.prototype.hasOwnProperty.call(payload, 'room') ||
    Object.prototype.hasOwnProperty.call(payload, 'gap') ||
    Object.prototype.hasOwnProperty.call(payload, 'snapshot')
  );
  const directFixture = payload?.fixture
    ?? (!isRecoveryEnvelope && (payload?.fixtureId != null || payload?.id != null) ? payload : null);
  let markets = null;
  if (Array.isArray(snapshot?.markets)) markets = snapshot.markets;
  else if (Array.isArray(payload?.markets)) markets = payload.markets;
  return {
    fixture: snapshot?.fixture ?? directFixture,
    markets,
    marketsPage: snapshot?.marketsPage ?? payload?.marketsPage ?? null,
    authority: snapshot?.authority ?? null,
    focusedOdds: Array.isArray(snapshot?.focusedOdds) ? snapshot.focusedOdds : [],
  };
};

const listSubscriptionFields = [
  'mode',
  'scope',
  'sport',
  'filterHash',
  'leagueId',
  'gameTitleId',
  'tournamentId',
  'status',
  'featured',
  'page',
  'limit',
];

export const subscriptionValue = (value) => value == null ? '' : String(value);

export const sportSlugOf = (sport) => (
  sport ? String(typeof sport === 'object' ? sport.slug : sport).trim() : ''
);

export const isListFilterModeScopeReady = ({ mode, scope }) => {
  const normalizedMode = String(mode || '').trim().toLowerCase();
  const normalizedScope = String(scope || '').trim().toLowerCase();
  if (normalizedMode === 'live') return normalizedScope === 'live';
  return normalizedScope !== 'live';
};

export const listSubscriptionChanged = (previous, next) => (
  !previous || listSubscriptionFields.some((field) => subscriptionValue(previous?.[field]) !== subscriptionValue(next?.[field]))
);

const subscriptionBoolean = (value) => value === true || value === 'true' || value === '1';

export const normalizedListSubscription = ({ echoed = {}, params = {}, hash, pageFallback, limitFallback }) => ({
  mode: echoed.mode ?? params.mode,
  scope: echoed.scope ?? params.scope,
  sport: echoed.sport ?? params.sport ?? 'all',
  filterHash: hash,
  leagueId: echoed.leagueId ?? echoed.league_id ?? params.league_id ?? null,
  gameTitleId: echoed.gameTitleId ?? echoed.game_title_id ?? params.game_title_id ?? null,
  tournamentId: echoed.tournamentId ?? echoed.tournament_id ?? params.tournament_id ?? null,
  status: echoed.status ?? params.status ?? null,
  featured: subscriptionBoolean(echoed.featured ?? params.featured),
  page: Number(echoed.page ?? params.page ?? pageFallback ?? 1) || 1,
  limit: Number(echoed.limit ?? params.limit ?? limitFallback ?? 30) || 30,
});

export const normalizeSportsnewCategories = (rows) => (
  Array.isArray(rows) ? rows : []
).map((category, index) => ({
  ...category,
  id: category.id ?? category.sportId ?? category.sport_id ?? category.slug ?? index,
  sportId: category.sportId ?? category.sport_id ?? category.id ?? null,
  sortOrder: categorySortOrder(category),
})).sort((a, b) => (
  categorySortOrder(a) - categorySortOrder(b)
  || sportFallbackOrder(a.slug) - sportFallbackOrder(b.slug)
  || String(a.slug || '').localeCompare(String(b.slug || ''))
));
